import type { BuilderComponent } from 'hb-builder/types';
import type { PartnersItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';

export interface LogosProps
  extends Pick<
    PartnersItemAttributes,
    'columnWidth' | 'logoBackground' | 'partnersCount' | 'template'
  > {
  component: BuilderComponent;
  components?: { [key: string]: BuilderComponent };
}

export const instantiateLogos = ({
  columnWidth,
  component: Component,
  components,
  logoBackground,
  partnersCount,
  template,
}: LogosProps) =>
  Array(partnersCount)
    .fill(null)
    .map((_, index) =>
      Component.item({
        columnWidth,
        logoBackground,
        partnersCount,
        template,
        components,
        index,
      }),
    );
